import { useQuery } from '@tanstack/react-query';

import { fetchPublicationClaims, fetchStoryClaims } from '../../api/subjectClaimsApi';
import { useToast } from '../../components/Toast/context/useToast.context';
import { subjectClaims as subjectClaimsMsgs } from '../../../locale/stories.en.locale.json';

import { subjectClaimsQueryKeys } from './subjectClaimsQueryKeys';

function getSubjectClaimsMsgs() {
  return subjectClaimsMsgs;
}

export function useSubjectStoryClaims(storyId: string | null) {
  const { toggleToast } = useToast();
  const msgs = getSubjectClaimsMsgs();

  return useQuery({
    queryKey: storyId
      ? subjectClaimsQueryKeys.storyClaims(storyId)
      : ([...subjectClaimsQueryKeys.all, 'storyClaims', 'disabled'] as const),
    queryFn: () => fetchStoryClaims(storyId!),
    enabled: !!storyId,
    refetchOnMount: 'always',
    onError: () => {
      toggleToast({
        title: msgs?.somethingWentWrongError ?? 'Something went wrong',
        body: msgs?.failedToFetchSubjectClaims ?? 'Failed to fetch subject claims',
        severity: 'error'
      });
    }
  });
}

export type UseSubjectPublicationClaimsParams = {
  publicationId: string;
  publicationClaims?: string[];
} | null;

export function useSubjectPublicationClaims(params: UseSubjectPublicationClaimsParams) {
  const { toggleToast } = useToast();
  const msgs = getSubjectClaimsMsgs();

  return useQuery({
    queryKey: params
      ? subjectClaimsQueryKeys.publicationClaims(params)
      : ([...subjectClaimsQueryKeys.all, 'publicationClaims', 'disabled'] as const),
    queryFn: () => fetchPublicationClaims(params!),
    enabled: params !== null && !!params.publicationId,
    refetchOnMount: 'always',
    onError: () => {
      toggleToast({
        title: msgs?.somethingWentWrongError ?? 'Something went wrong',
        body: msgs?.failedToFetchSubjectClaims ?? 'Failed to fetch subject claims',
        severity: 'error'
      });
    }
  });
}
